import {Box, Chip, Container, Divider, Link, Typography} from "@mui/material";
import {motion, useAnimation, useInView} from "framer-motion";
import {useEffect, useRef} from "react";
import {useParams} from "react-router-dom";
import LandingPage from "../LandingPage/LandingPage";
import experiences from "../../data/experience";

const renderMoreItem = (item) => {
    if (typeof item === "string") {
        return item;
    }

    return item.parts.map((part, index) => {
        if (typeof part === "string") {
            return part;
        }

        return (
            <Link key={index} href={part.href} target="_blank" rel="noreferrer">
                {part.label}
            </Link>
        );
    });
};

const ExperienceSubPage = () => {
    const {id} = useParams();
    const item = experiences.find(project => project.id === id);


    const ref = useRef(null);
    const controls = useAnimation();
    const isInView = useInView(ref, {once: false, amount: 0.2}); // Detects if it's in view

    useEffect(() => {
        if (isInView) {
            controls.start({opacity: 1, y: 0});
        }
    }, [isInView, controls]); // Runs when the view state changes

    if (!item) {
        return <LandingPage/>;
    }

    return (
        <>
            <Container>
                <Box sx={{
                    paddingTop: '20px',
                    paddingBottom: '40px',
                    // py: 5,
                    px: {xs: 3, md: 6},
                    textAlign: "left",
                    color: "white"
                }}>
                    <motion.div
                        ref={ref}
                        transition={{duration: 0.3}}
                        initial={{opacity: 0, y: 50}}
                        animate={controls} // Now controlled by `useAnimation`
                        whileInView={{opacity: 1, y: 0}}
                    >
                        <Box sx={{display: "flex", justifyContent: "space-between"}}>
                            <Box sx={{height: '100%', alignItems: 'center'}}>
                                {/* Title & Underline */}
                                <Typography
                                    variant="h5"
                                    sx={{
                                        fontWeight: "bold",
                                        textTransform: "uppercase",
                                        fontFamily: `"Poppins", sans-serif`,
                                        display: "inline-block",
                                        fontSize: {xs: '14px', md: '24px'},
                                    }}
                                >
                                    {item.title}
                                </Typography>
                                <Divider
                                    sx={{
                                        backgroundColor: "#FFD700", // Faint Gold Underline
                                        height: "2px",
                                        width: "80px",
                                        mt: 1,
                                        mb: 4,
                                        // mx: "auto",
                                    }}
                                />
                            </Box>
                        </Box>
                        <Box>
                            <ul style={{
                                listStyle: 'none',
                                paddingLeft: '0px',
                                gap: '10px',
                            }}>
                                <li style={{paddingBottom: '10px'}}>
                                    <Chip color="success" label="Role"/> {item.role}
                                </li>
                                <li style={{paddingBottom: '10px'}}>
                                    <Chip color="success" label="Website"/> <Link href={item.website}
                                                                                  target="_blank"
                                                                                  rel="noreferrer"> {item.website}</Link>
                                </li>
                                <li style={{paddingBottom: '10px'}}>
                                    <Chip color="success" label="Duration"/> {item.duration}
                                </li>
                                <li style={{paddingBottom: '10px'}}>
                                    <Chip color="success" label="Location"/> {item.location}
                                </li>
                                <li style={{paddingBottom: '10px'}}>
                                    <Chip color="success" label="More"/>
                                    <ul>
                                        {item.more.map((moreItem, index) => (
                                            <li key={index}>
                                                <p>
                                                    {renderMoreItem(moreItem)}
                                                </p>
                                            </li>
                                        ))}
                                    </ul>
                                </li>
                            </ul>
                        </Box>
                    </motion.div>
                </Box>
            </Container>
        </>
    )
}

export default ExperienceSubPage;
